import defer from 'Utils/defer'
import Agencies from 'DataServices/Agencies'

// TODO: PERMS - need to make one of these per agency ID that has been requested in the FE
class AgencyResourceAggregator {
  _promises = []
  _requestInFlight = false
  _agencyId = null

  constructor (agencyId) {
    this._agencyId = agencyId
  }

  requestResources () {
    let deferred = defer()

    this._promises.push(deferred)

    if (!this._requestInFlight) {
      this._requestInFlight = true
      Agencies.getResources({ agency_id: this._agencyId })
        .then(resources => {
          while (this._promises.length > 0) {
            this._promises.shift().resolve(resources)
          }
          this._requestInFlight = false
        })
        .catch(resp => {
          while (this._promises.length > 0) {
            this._promises.shift().reject(resp)
          }
          this._requestInFlight = false
        })
    }

    return deferred.promise
  }
}

class AgencyResources {
  _aggregatorsByAgencyId = {}

  requestResources ({ agency_id }) {
    if (!this._aggregatorsByAgencyId[agency_id]) {
      this._aggregatorsByAgencyId[agency_id] = new AgencyResourceAggregator(agency_id)
    }

    return this._aggregatorsByAgencyId[agency_id].requestResources()
  }
}

export default new AgencyResources()
